// @flow

import { observer } from "mobx-react";
import React from "react";
import Icon from "app/components/Icon/Icon";
import MediaRecorderStore from "app/stores/MediaRecorderStore";

import "./MediaRecorderButton.scss";
import { autorun } from "mobx";

type Props = {
    disabled: boolean,
    icon: string,
    text: string,
    onRecorded: Function
};

@observer
export default class MediaRecorderButton extends React.Component<Props> {
    disposeFileHandler: Function;

    handleTrigger() {
        MediaRecorderStore.openRecorder();
    }

    componentWillMount() {
        this.disposeFileHandler = autorun(() => {
            if (MediaRecorderStore.recordedFile) {
                MediaRecorderStore.closeRecorder();
                this.props.onRecorded(MediaRecorderStore.recordedFile);
                MediaRecorderStore.reset();
            }
        });
    }

    componentWillUnmount() {
        this.disposeFileHandler();
    }

    render() {
        return (
            <div className="MediaRecorderButton">
                <button
                    type="button"
                    className="MediaRecorderButton__button"
                    disabled={this.props.disabled}
                    onClick={this.handleTrigger.bind(this)}
                >
                    <Icon name={this.props.icon} fontAwesome={true} />{" "}
                    {this.props.text}
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/MediaRecorderButton/MediaRecorderButton.js